import { useEffect, useState } from "react";
import { useSetLogAcesso } from "~hooks/useBackOffice";
import { getPagina } from "~services/GlobalServices";
import useUsuario from "~fetchs/useUsuario";

const useLogAcessoManual = () => {
  const { usuario } = useUsuario();

  const [geoLocation, setGeoLocation] = useState(null);
  const [pagina, setPagina] = useState(null);
  const [enable, setEnable] = useState(false);

  useSetLogAcesso(enable, geoLocation, pagina);

  const getLocation = () => {
    return new Promise((resolve) => {
      if ("geolocation" in navigator && !usuario?.slugAcessos?.includes('nao-capturar-lat-long')) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude, accuracy } = position.coords;
            resolve({
              latitude,
              longitude,
              precisaoMetros: accuracy
            });
          },
          (error) => {
            console.warn("Erro ao obter localização:", error.message);
            resolve({
              latitude: null,
              longitude: null,
              precisaoMetros: null
            });
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
          }
        );
      } else {
        console.warn("Geolocation não é suportado pelo seu navegador.");
        resolve({
          latitude: null,
          longitude: null,
          precisaoMetros: null
        });
      }
    });
  };

  const logarAcesso = async (paginaParam) => {
    const location = await getLocation();
    setGeoLocation(location);
    const pagina = getPagina(paginaParam)
    setPagina(pagina);
    setEnable(true);
  };

  const isAdmin = usuario?.usuarioPerfils?.some(p => p?.perfil?.slug === "admin") ?? false;

  return {
    logarAcesso,
    geoLocation,
    pagina,
    enable,
    isAdmin,
  };
};

export default useLogAcessoManual;
